import React from 'react'
import { Button } from '@mui/material'
import { PRIMARY_COLOR } from '../colorPalette'

const styles = {
    filledButton: {
      // backgroundColor: PRIMARY_COLOR,
      color: PRIMARY_COLOR,
      borderRadius: '30px',
      textTransform: 'none',
      width: '250px',
      height: '60px',
      padding: '15px 0',
      fontSize: '18px',
    },
  }
  

function RoundedFilledIconButton({children, onClick, customStyles, icon, ...props}) {
    return (
        <Button {...props} onClick={onClick} variant="outlined" startIcon={icon} style={{...styles.filledButton, ...customStyles}}>
          {children}
        </Button>
    )
}

export default RoundedFilledIconButton